module.exports = __webpack_public_path__ + "static/media/huangyi.ef3f8432.png";